import { useContext, useRef } from 'react'

import { CircularProgress, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CkEditorTextbox from '@scoir/components-core/dist/components/CkEditorTextbox'

import window from 'browser-lib/window'

import ContentModalContext from '../../../ContentModalProvider/Context'
import { FIELD_NAMES, ERROR_MESSAGES, LABELS } from '../../../components/constants'
import ValidationMessage from '../../../components/ValidationMessage'
import { useLoadCkEditor } from './use-load-ckeditor'

const useStyles = makeStyles(() => ({
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
  },
}))

const label = LABELS.DESCRIPTION
interface DescriptionProps {
  onToggleEnforceFocus?: () => void
}

const Description = ({ onToggleEnforceFocus }: DescriptionProps) => {
  const classes = useStyles()
  const isLoaded = useLoadCkEditor()
  const { item, onUpdateField } = useContext(ContentModalContext)
  const value = item[FIELD_NAMES.DESCRIPTION]
  const touchedRef = useRef(false)
  const touched = touchedRef.current
  return (
    <>
      <Typography variant="subtitle2">{`${label}*`}</Typography>
      <div>
        {isLoaded ? (
          <CkEditorTextbox
            additionalOptions={{
              startupFocus: false,
              versionCheck: false,
            }}
            onHideDialog={onToggleEnforceFocus}
            onShowDialog={onToggleEnforceFocus}
            initialContent={value}
            configuration="LINKS"
            ckEditor={window.CKEDITOR}
            onUpdate={(value: string) => {
              touchedRef.current = true
              onUpdateField(FIELD_NAMES.DESCRIPTION, value)
            }}
          />
        ) : (
          <div className={classes.loading}>
            <CircularProgress
              role="status"
              aria-label="Loading"
              size="small"
            />
          </div>
        )}

        <ValidationMessage
          label={label}
          touched={touched}
          valuesByError={{
            [ERROR_MESSAGES.REQUIRED]: value,
          }}
        />
      </div>
    </>
  )
}

export default Description
